import React from 'react';
import './MetricCard.css';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PeopleIcon from '@mui/icons-material/People';
import AssignmentIcon from '@mui/icons-material/Assignment';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import BarChartIcon from '@mui/icons-material/BarChart';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';

const MetricCard = ({ data, prompt }) => {
  const key = Object.keys(data)[0];
  const value = data[key];
  
  // Format the metric value
  const formatMetricValue = (val) => {
    const numValue = parseFloat(val);
    
    if (isNaN(numValue)) {
      return val;
    }
    
    // Currency formatting
    if (key.toLowerCase().includes('revenue') || 
        key.toLowerCase().includes('total') || 
        key.toLowerCase().includes('amount') ||
        key.toLowerCase().includes('price')) {
      return `₹${numValue.toLocaleString('en-IN', { 
        minimumFractionDigits: 2,
        maximumFractionDigits: 2 
      })}`;
    }
    
    // Large number formatting
    if (numValue >= 1000000) {
      return `${(numValue / 1000000).toFixed(1)}M`;
    } else if (numValue >= 1000) {
      return `${(numValue / 1000).toFixed(1)}K`;
    }
    
    // Percentage formatting
    if (key.toLowerCase().includes('percent') || 
        key.toLowerCase().includes('rate') ||
        numValue <= 1 && numValue > 0) {
      return `${(numValue * 100).toFixed(1)}%`;
    }
    
    return numValue.toLocaleString();
  };

  // Get icon based on metric type
  const getMetricIcon = () => {
    const keyLower = key.toLowerCase();
    
    if (keyLower.includes('revenue') || keyLower.includes('sales')) {
      return <AttachMoneyIcon fontSize="inherit" />;
    }
    if (keyLower.includes('customer') || keyLower.includes('user')) {
      return <PeopleIcon fontSize="inherit" />;
    }
    if (keyLower.includes('order') || keyLower.includes('transaction')) {
      return <AssignmentIcon fontSize="inherit" />;
    }
    if (keyLower.includes('growth') || keyLower.includes('increase')) {
      return <TrendingUpIcon fontSize="inherit" />;
    }
    if (keyLower.includes('product') || keyLower.includes('item')) {
      return <ShoppingBagIcon fontSize="inherit" />;
    }
    
    return <BarChartIcon fontSize="inherit" />;
  };

  // Simulate trend (since we don't have historical data)
  const getTrendIndicator = () => {
    const trends = [
      { type: 'up', value: '+12.5%' },
      { type: 'down', value: '-3.2%' },
      { type: 'flat', value: '0.0%' },
      { type: 'up', value: '+8.7%' }
    ];
    const picked = trends[Math.floor(Math.random() * trends.length)];
    if (picked.type === 'up') return (<><TrendingUpIcon fontSize="small" style={{ marginRight: 6 }} /> {picked.value}</>);
    if (picked.type === 'down') return (<><TrendingDownIcon fontSize="small" style={{ marginRight: 6 }} /> {picked.value}</>);
    return (<><TrendingFlatIcon fontSize="small" style={{ marginRight: 6 }} /> {picked.value}</>);
  };

  return (
    <div className="metric-card">
      <div className="metric-header">
        <div className="metric-icon">{getMetricIcon()}</div>
        <div className="metric-label">{key}</div>
      </div>
      
      <div className="metric-value">
        {formatMetricValue(value)}
      </div>
      
      <div className="metric-trend">
        {getTrendIndicator()}
      </div>
      
      <div className="metric-description">
        Based on: "{prompt}"
      </div>
    </div>
  );
};

export default MetricCard; 